export const defaultSegmentHeight = 133;